import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-home',
  templateUrl: './icon-home.component.html',
  styleUrls: ['./icon-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconHomeComponent {}
